<app-makecode-blocks-filter
  [(open)]="displayBlocksFilter"
  [(filters)]="filters"
  (updateFilters)="applyFilters()"
  [projectDependencies]="projectDependencies"></app-makecode-blocks-filter>
<iframe #editor title="Tenjin MakeCode"></iframe>
